import React, { useState, createContext, useContext, useMemo, useEffect } from "react";
import "./style.scss";
import ShoppingCartPromo from "./ShoppingCartPromo";
import ProductRecommendation from "./ProductRecommendations";
import ShoppingCartHeading from "./ShppingCartHeading";
import IteminCart from "./ItemInCart";
import AddPartNumber from "./AddPartNumber";
import PartNumberCard from "./PartNumberCard";
import BreadCrumbs from "./BreadCrumbs";
import { ModalPopup, TreeviewDropdown } from "../CommonComponent";
import { Iprops } from "./shoppingcartinterface";   
import FreightCalculator from "./ShoppingCartPromo/FrieghtCalculator/frieghtcalculator";
import MaintenancePartList from "./MaintenancePartList";
import SavePartList from "./SavePartList";
import AddPartList from "./AddPartList";
import DealerAvailability from "./DealerAvailability";
import SharePartList from "./SharePartList";
import Quotes from "./Quotes";
import DropShip from "../DropShip";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../const/resource";
import helperfunctions from "../../utils/helperfunctions";
import Loader from "../Loader";
import SaveCartPopUp from "./SaveCartPopUp";
import { useSelector } from "react-redux";
import { selectors as globalDataSelector } from "../../state/features/common/globaldata";
import { selectors as headerSelector } from '../../state/features/header';
import partsService from "../../services/partsservice";
import UploadPartsList from "./UploadPartsList";
import { ICartContextType } from "./ShoppingCartPromo/shoppingcartpromointerface";
import Alerts from "../Alerts";
import ShoppingCartLoader from "./ShopCartLoader";
import { useSearchParams } from "react-router-dom";
import isEqual from "lodash/isEqual";
import { PAYMENTMETHOD } from "../../const/enum";
import PunchOutHistory from "../DropShip/PunchOutHistory";
import Confirmation from "../DropShip/Confirmation";
import machineservice from "../../services/machineservice";
import { toast } from 'react-toastify';
import { confirmDailog } from "../ConfirmDailog";
import {
    selectors as orderSelector
} from "../../state/features/orderdetail";
import MiningPartsLists from "./MiningPartsLists";
import { IAppContextProps } from "../App/AppInterface";
import { useAppContext } from "../App/App";
import KomatsuCreditHistory from "../DropShip/KomatsuCreditHistory";

const CartContext = createContext<ICartContextType>({
    cartsDetails: {},
    stepperDetails: undefined,
    updateStepIndex: () => { },
    currentStep: undefined,
    isHideItemSummary: false,
    itemSummaryDetails: {},
    isStepTwoLoading: false,
    isStepOneLoading: false,
    isGuestUser: false,
});

const ShoppingCart = (props: Iprops) => {
    const { cartToolMenu, setcartToolMenu, punchoutButtonVisibility, komatsuCreditHistoryButtonVisibility, isDropshipEnable, mvcPunchoutHistoryUrl, distributorContactsInfo, setShowCreditWarningMsg, isCartListLoading } = props;
    const { t } = useTranslation();
    const [manufactureValue,] = useState("");
    const [machineValue,] = useState("");
    const [isReturnable, setIsReturnable] = useState(false);
    const [isEstimatedPopup, SetIsEstimatedPopup] = useState(false);
    const [isSaveCartPopup, SetSaveCartPopup] = useState(false);
    const [isUploadPopup, SetUploadPopup] = useState(false);
    const [isSavedPartsPopup, SetSavedPartsPopup] = useState(false);
    const [isAddtoListPopup, SetAddtoListPopup] = useState(false);
    const [isDealerAvilablityPopup, setIsDealerAvilablityPopup] = useState(false);
    const [isSharePopup, SetSharePopup] = useState(false);
    const [isQuotesPopup, SetQuotesPopup] = useState(false);
    const [isShoppingCart, setIsShoppingCart] = useState(true);
    const [isordersummary, Setordersummary] = useState(false);
    const [istoolmenu, Settoolmenu] = useState(true);
    const [isCheckoutButton, setIsCheckoutButton] = useState(true);
    const [isCheckoutPage, setIsCheckoutPage] = useState(false);
    const [isnextbutton, setnextbutton] = useState(false);
    const [isActive, setActive] = useState(false);
    const [isPriceAndAvailabilityRequired, setIsPriceAndAvailabilityRequired] = useState(false);
    const [saveCartRes, setSaveCartRes] = useState({ loading: false, data: {} })
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<string>('');
    const [errorSuccessMessage, setErrorSuccessMessage] = useState<string>("");
    const [errorMandatoryMessage, setErrorMandatoryMessage] = useState<string>("");
    const [searchParams] = useSearchParams();
    const [quoteId, setQuoteId] = useState<number>(parseInt(searchParams?.get("quoteId") ?? "0"));
    const [showMandatoryAlert, setShowMandatoryAlert] = useState<boolean>(false);
    const [showPuchoutHistory, setShowPuchoutHistory] = useState<boolean>(false);
    const [showKomatsuCreditHistory, setShowKomatsuCreditHistory] = useState<boolean>(false);
    const [phoneCodeOption, setPhoneCodeOption] = useState<any>([]);
    const [estPartNumber, setEstPartNumber] = useState<any>("");
    const [savePickupRes, setSavePickupRes] = useState({ loading: false, data: false });
    const [isApplyCredit, setIsApplyCredit] = useState(false);
    const [isPromoChanges, setIsPromoChanges] = useState(false);
    const { isMixedFleetDistributor, isWacMixedFleetDistributor }: IAppContextProps = useAppContext();
    const {
        headercurrentuser,
        globalData
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            globalData: globalDataSelector.globaldata(state),
        })
    );
    const formWizardRef = React.createRef<any>();

    const {
        enableDropshipFlag
    }: any = useSelector((state) => ({
        enableDropshipFlag: orderSelector.enableDropshipFlag(state)
    }));

    useEffect(() => {
        if (props.page === 'quotes') {
            SetQuotesPopup(true);
        }
        else if (props.page === 'punchouthistory') {
            puchoutHistoryOnClick();
        }
        else if (props.page === 'komatsucredithistory') {
            komatsuCreditHistoryOnClick();
        }
        else if (props.page === 'savedpartslist') {
            SetSavedPartsPopup(true);
        }
    }, [props.page, isDropshipEnable]);

    useEffect(() => {
        if (quoteId > 0) {
            SetQuotesPopup(true);
        }
    }, [quoteId])

    useEffect(() => {
        if (localStorage.getItem("isShoppingCartRefresh") === 'true' && (globalData?.BranchCode ?? "") != "" && (globalData?.DistributorCode ?? "") != "" &&
            (((globalData?.CustomerId ?? "") != "" && (globalData?.LocationId ?? "") != "" && globalData?.BranchName) || headercurrentuser?.isGuestUser)) {
            setIsShoppingCart(true);
            setShowPuchoutHistory(false);
            setShowKomatsuCreditHistory(false);
            if (isordersummary) {
                shoppingcartOnClick();
            } else if (props?.refreshCartRequiredParts?.length) {
                props?.onRefresh();
            } else {
                props?.getCartItems();
            }
        }
        localStorage.setItem("isShoppingCartRefresh", "false");
    }, [localStorage.getItem("isShoppingCartRefresh")])

    const checkboxList = props?.childCheckboxes ?? {};
    const hasTrueValue = Object.values(checkboxList).some(value => value === true);
    const {fulfillmentDetailRes, paymentInfoRes, shippingMethodsRes, saveShipmentDetailsRes, stepperDetails, cartsDetails, updateStepIndex, currentStep, itemSummaryDetails, placeOrderRes } = props ?? {};

    const contextValue = useMemo<ICartContextType>(() =>
    (
        {
            itemSummaryDetails,
            cartsDetails,
            stepperDetails,
            updateStepIndex,
            currentStep,
            isStepTwoLoading: paymentInfoRes?.loading,
            isStepOneLoading: !props?.isStepOneLoadingCompleted || fulfillmentDetailRes?.loading || props?.savedAddressRes?.loading || shippingMethodsRes?.loading || savePickupRes?.loading || props?.savedAddressRes?.loading,
            isHideItemSummary: (currentStep === 3 && placeOrderRes?.data?.isSuccessful === true),
            isGuestUser: headercurrentuser?.isGuestUser,
        }
    ), [ headercurrentuser?.isGuestUser, fulfillmentDetailRes, props?.isStepOneLoadingCompleted, savePickupRes, cartsDetails, stepperDetails, paymentInfoRes, updateStepIndex, itemSummaryDetails, shippingMethodsRes, currentStep, saveShipmentDetailsRes, props?.savedAddressRes?.loading, placeOrderRes]);

    useEffect(() => {
        if (currentStep || currentStep == 0) {
            helperfunctions.scrollToTop();
        }
    }, [currentStep])

    const showErrorMessage = (message: any, type: string) => {
        setErrorSuccessMessage(message);
        setAlertType(type);
        setShowAlert(true);
    }

    const showMandtoryErrorMessage = (message: any) => {
        setErrorMandatoryMessage(message);
        setShowMandatoryAlert(true);
    }

    const handleMandatoryErrorClose = () => {
        setErrorMandatoryMessage('');
        setShowMandatoryAlert(false);
    };

    useEffect(() => {
        if (props.openSavePartList) {
            SetSavedPartsPopup(true);
        }
    }, [props?.openSavePartList]);

    const showCreditWarning = () => {
        let intervalId = setInterval(() => {
            if (!headercurrentuser?.isGuestUser && !props?.itemSummaryDetails?.data?.isCustomerCreditAvailable && !(props?.itemSummaryDetails?.data?.isCustomerApplicable ?? false)) {
                setShowCreditWarningMsg(true);
            }
            clearInterval(intervalId);
        }, 3000)
    }

    const applyCredit = () => { 
        setIsApplyCredit(true);
    }

    const checkCallbackAndProceedCheckout = (komatsuCreditConfirmation: any) => {
        if (typeof komatsuCreditConfirmation === 'function') {
            komatsuCreditConfirmation(processCheckout);
        }
        else {
            processCheckout();
        }
    }

    const getDistributorId = () => {
        return isNaN(globalData?.DistributorCode) ? parseInt(globalData?.DistributorId) : parseInt(globalData?.DistributorCode);
    }

    const CheckoutPageTransfer = (komatsuCreditConfirmation: any) => {
        const req = {
            cartId: cartsDetails?.cart?.cartId,
            userAadId: headercurrentuser?.azureADId,
            distributorId: getDistributorId(),
            customerId: globalData?.CustomerId,
            isGuest: headercurrentuser?.isGuestUser
        }
        partsService.getItemSummaryDetails(req).then((response: any) => {
            if (response?.isSuccess) {
                const total = response?.data?.total ?? 0;
                if (total < 0) {
                    partsService.clearPartsCredit(props.cartsDetails?.cart?.cartId, headercurrentuser?.azureADId)
                        .then((response: any) => {
                            if (response.isSuccessful) {
                                const confimObject = {
                                    title: t(RESOURCE.MyK_Label_Confirm_Title),
                                    message: '',
                                    confirmmessage: t(RESOURCE.MyK_Label_SC_PartCreditRemoved_Confirmation),
                                    buttonLabel: {
                                        yes: t(RESOURCE.MyK_Label_Yes),
                                        no: t(RESOURCE.MyK_Label_No),
                                    },
                                    yesOnclick: () => {
                                        props.getItemSummaryDetailsWithoutLoading(applyCredit);
                                    },
                                    noOnclick: () => {
                                        props.getItemSummaryDetailsWithoutLoading();
                                        checkCallbackAndProceedCheckout(komatsuCreditConfirmation);
                                    },
                                }
                                confirmDailog(confimObject);
                            }
                            else {
                                checkCallbackAndProceedCheckout(komatsuCreditConfirmation);
                            }
                        })
                        .catch((e: any) => {

                        });
                }
                else {
                    checkCallbackAndProceedCheckout(komatsuCreditConfirmation);
                }
            }
            else {
                checkCallbackAndProceedCheckout(komatsuCreditConfirmation);
            }
        });
    }

    const getTotal = (total :any) => {
        return (total ?? 0);
    }

    const showPartCreditWhenPromoApplied = () => {
        const { isKomatsuCreditApplied } = props?.itemSummaryDetails?.data ?? false;
        if (isKomatsuCreditApplied) {
            const req = {
                cartId: cartsDetails?.cart?.cartId,
                userAadId: headercurrentuser?.azureADId,
                distributorId: getDistributorId(),
                customerId: globalData?.CustomerId,
                isGuest: headercurrentuser?.isGuestUser
            }

            partsService.getItemSummaryDetails(req).then((response: any) => {
                if (response?.isSuccess) {
                    const total = getTotal(response?.data?.total);
                    if (total < 0) {
                        partsService.clearPartsCredit(props.cartsDetails?.cart?.cartId, headercurrentuser?.azureADId)
                            .then((response: any) => {
                                if (response.isSuccessful) {
                                    const confimObject = {
                                        title: t(RESOURCE.MyK_Label_Confirm_Title),
                                        message: '',
                                        confirmmessage: t(RESOURCE.MyK_Label_SC_PartCreditRemoved_Confirmation),
                                        buttonLabel: {
                                            yes: t(RESOURCE.MyK_Label_Yes),
                                            no: t(RESOURCE.MyK_Label_No),
                                        },
                                        yesOnclick: () => {
                                            props.getItemSummaryDetails();
                                            applyCredit();
                                        },
                                        noOnclick: () => {
                                            props.getItemSummaryDetails();
                                        },
                                    }
                                    confirmDailog(confimObject);
                                }
                            })
                            .catch((e: any) => {

                            });
                    }
                }
            });
        }
    }

    const processCheckout = () => {
        checkCreditCardEnableAndCreditLimit().then((response: any) => {
            if (response) {
                Setordersummary(true)
                setcartToolMenu(true);
                setIsShoppingCart(false)
                setShowPuchoutHistory(false);
                setShowKomatsuCreditHistory(false);
                Settoolmenu(false)
                checkoutOnClick();
                props.updateStepOne();
                getCountryWithPhoneCodeList();
                showCreditWarning();
            }
            else {
                let errrorMessage = (t(RESOURCE.Myk_Label_SC_Credit_Card_Disabled_CreditLimit_Msg))?.replace("{0}", distributorContactsInfo?.name)?.replace("{1}", distributorContactsInfo?.phone);
                helperfunctions.showErrorMessage(errrorMessage);
            }
        })
    }

    const checkCreditCardEnableAndCreditLimit = async () => {
        if (enableDropshipFlag) {
            let paymentOptions = await partsService.getPaymentMethodList(headercurrentuser?.azureADId, props.cartsDetails?.cart?.cartId, headercurrentuser?.isGuestUser);
            let isCODEnable = paymentOptions?.data?.paymentOption?.find((s: any) => s?.paymentTypeCode?.toLowerCase() == PAYMENTMETHOD[PAYMENTMETHOD.CO].toLowerCase())?.isEnabled ?? false;
            let isOpenAccountEnable = paymentOptions?.data?.paymentOption?.find((s: any) => s?.paymentTypeCode?.toLowerCase() == PAYMENTMETHOD[PAYMENTMETHOD.AC].toLowerCase())?.isEnabled ?? false;
            if (!isCODEnable && (!isOpenAccountEnable || (isOpenAccountEnable && !(props?.itemSummaryDetails?.data?.isCustomerApplicable ?? false))) && ((props?.itemSummaryDetails?.data?.total ?? 0) > (props?.itemSummaryDetails?.data?.customerAvailableCredit ?? 0))) {
                return false;
            }
        }
        return true;
    }

    const Ordersummaryonclick = (komatsuCreditConfirmation: any) => {
        toast.dismiss("creditwarningtoaster");
        if (props.quantityChange || props.isNewPartAdded(cartsDetails)) {
            props.onRefresh(() => CheckoutPageTransfer(komatsuCreditConfirmation), true);
        }
        else
        {
           CheckoutPageTransfer(komatsuCreditConfirmation);
        }
    };

    const shoppingcartOnClick = () => {
        setIsShoppingCart(true);
        Settoolmenu(true);
        Setordersummary(false);
        setnextbutton(false);
        setIsCheckoutButton(true);
        setIsCheckoutPage(false);
        setShowPuchoutHistory(false);
        setShowKomatsuCreditHistory(false);
        if (props?.updateStepperDetails) {
            props.updateStepperDetails({}, true);
        }
        props.getMaintenancePartsList();
        setPrevStepperDetails({});
        props?.updateStepStatus({});
        props?.updateStepIndex(0);
        props?.setPlaceOrderRes({ loading: false, data: {} });
        const isOrderPlaced = localStorage.getItem("isOrderPlaced") === "true";
        if (!isOrderPlaced) {
            props?.clearCartCheckOutData();
        } else {
            localStorage.setItem("isOrderPlaced", "false");
            setcartToolMenu(false);
        }
        helperfunctions.scrollToTop();
    };

    const getCountryWithPhoneCodeList = () => {
        machineservice.GetCountryCodes()
            .then((response: any) => {
                const data = response?.map((t: any) => ({ value: `${t.isd}|${t.countryCodeAlpha2}|${t.name}`, title: `${t.isd} ${t.name}` })) ?? []
                const defaultOption = { value: '', title: t(RESOURCE.MyK_Select) };
                const options =  [defaultOption].concat(data);
                setPhoneCodeOption(options);
            })
            .catch((e: any) => {
            });
    }

    const toolmenuOnclick = () => {
        setcartToolMenu(!cartToolMenu);
    };

    const ReturnableOnClick = () => {
        setIsReturnable(!isReturnable);
    };

    const estOnClick = (partNumber : any = "") => {
        SetIsEstimatedPopup(!isEstimatedPopup);
        setEstPartNumber(partNumber);
    };

    const handleManufactureOption = (manufacturer: any) =>
    {
        const isOtherText = manufacturer?.name?.toLowerCase() === "other";
        const hasOtherOption = props.manufactureOption?.some(
            (t: any) => t.value === 0 || t.title?.toLowerCase() === "other"
        );

        if (hasOtherOption && !isOtherText) {
            const filteredOptions = props.manufactureOption?.filter(
                (t: any) => t.value !== 0 && t.title?.toLowerCase() !== "other"
            );
            props.setManufactureOption(filteredOptions);
        } else if (!hasOtherOption && isOtherText) {
            props.manufactureOption.unshift({ title: "Other", value: 0 });
            props.setManufactureOption([...props.manufactureOption]);
        }
    }

    const handleOnChange = (newValue: any, text: any, name: string) => {
        if (name == "machine") {
            let machine = props?.machineOption?.find((t: any) => t.value == newValue);
            props.setMachineManufactureModel((prevState: any) => ({
                ...prevState,
                machine: {
                    modelDisplay: text[0],
                    mDbId: newValue,
                    model: machine?.model,
                    serial: machine?.serial,
                    unitNumber: machine?.unit,
                }
            }));
        }
        else {
            
            props.setMachineManufactureModel((prevState: any) => ({
                ...prevState,
                manufacturer: {
                    code: newValue,
                    name: text[0]
                }
            }));
        }
    };

    const SaveOnClick = () => {
        SetSaveCartPopup(!isSaveCartPopup);
    };

    const saveCartService = async (saveCartDetails: any) => {
        try {
            const data = checkboxList ?? {};
            let checkedPartNumbers:any[] = [];
            const selectedItems = Object.keys(data).filter(key => data?.[key])
            props?.cartsDetails?.parts?.filter((s: any) => selectedItems?.indexOf(String(s.cartDetailId)) > -1)?.forEach((item: any) => {                
                checkedPartNumbers.push(item.partNumber);
            });
            setSaveCartRes({ loading: true, data: [] });
            const partNumber: any = hasTrueValue ? checkedPartNumbers.join(',') : '';
            const reqBody = {
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                listType: saveCartDetails?.selectedListType ?? '',
                listName: saveCartDetails?.shoppingListName ?? '',
                cartId: props.cartsDetails?.cart?.cartId,
                userAadId: headercurrentuser?.azureADId ?? '',
                selectSave: hasTrueValue,
                partsNo: partNumber,
                cartDetailIds: selectedItems.join(',')
            };
            partsService.saveCartList(reqBody).then((response: any) => {
                setSaveCartRes({ loading: false, data: response ?? {} });
                if (response?.isSuccessful) {
                    props.getPartsListItems();
                    showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Cart_Save_Success_Msg), 'success')
                } else {
                    showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Cart_Save_Error_Msg), 'error')
                }
            }).catch((error: any) => {
                setSaveCartRes({ loading: false, data: [] });
                showErrorMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_Cart_Save_Error_Msg)} - ${error}`, 'error');
            })
        } catch (error) {
            setSaveCartRes({ loading: false, data: [] });
            showErrorMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_Cart_Save_Error_Msg)} - ${error}`, 'error');
        }
    };

    const onSaveCartChange = (saveInfo: any) => {
        SaveOnClick();
        saveCartService(saveInfo);
    };

    const closePopup = () => {
        SetSaveCartPopup(false);
    }

    const uploadOnClick = () => {
        SetUploadPopup(!isUploadPopup)
    };

    const savedpartsOnClick = () => {
        if (globalData.CustomerId == '' || globalData.DistributorId == '' || globalData.LocationId == '') {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_DistCusLocValidation));
        }
        else {
            props.setSelectedBookmarkItem([]);
            SetSavedPartsPopup(!isSavedPartsPopup)
        }
    };

    const ShareOnClick = () => {
        if (!hasTrueValue && !isSharePopup) {
            showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Share_Validation), 'error');
        } else {
            SetSharePopup(!isSharePopup);
        }
    };

    const DeleteOnClick = () => {
        if (!hasTrueValue) {
            showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Delete_Validation), 'error');
        }
        else {
            props.deletePartNumbers();
        }
    };

    const puchoutHistoryOnClick = () => {
        if (isDropshipEnable) {
            setShowPuchoutHistory(true);
            setShowKomatsuCreditHistory(false);
            Setordersummary(false);
            setIsShoppingCart(false);
        }
        else {
            if (mvcPunchoutHistoryUrl) { 
                window.open(mvcPunchoutHistoryUrl, "_self");
            }
        }
    }

    const komatsuCreditHistoryOnClick = () => {
        setShowPuchoutHistory(false);
        setShowKomatsuCreditHistory(true);
        Setordersummary(false);
        setIsShoppingCart(false);
       
    }


    const historyOnClick = () => {
        window.location.href = '/orderhistory';
    }

    const removeQueryString = () => {
        const url = window.location.origin + window.location.pathname;
        window.history.replaceState(null, '', url);
        localStorage.removeItem('isViewQuote');
    }

    const quotesOnClick = () => {
        if(localStorage.getItem('isViewQuote') === 'true') {
            removeQueryString();
        }
        SetQuotesPopup(!isQuotesPopup)
    };

    const addtoListOnClick = () => {
        if (isAddtoListPopup)
            props.setSelectedBookmarkItem([]);

        SetAddtoListPopup(!isAddtoListPopup);
    };

    const dealerAvilablityOnClick = () => {
        setIsDealerAvilablityPopup(!isDealerAvilablityPopup)
    };

    const isHideItemSummary = props?.currentStep === 3 && props?.placeOrderRes?.data?.isSuccessful === true;

    useEffect(() => {
        if (props?.placeOrderRes?.data?.isSuccessful === true) {
            props?.getCartItems();
        }
    }, [props?.placeOrderRes?.data]);

    const fieldConditionMatch = (shipment: any, field: any) => {
        const value = shipment?.[field] ? shipment?.[field].toString() : ''
        return ((field !== 'addressId' && !value?.trim()?.length) || (field === 'addressId' && shipment?.[field] == null));
    }

    const stepOneValidationCheck = () => {
        const shipment = stepperDetails?.shipment ?? {};
        const { isShippingType } = shipment;
        let requiredFields : any = [];
        let isValid = true;
        if (isShippingType) {
            shipment['addressId'] = shipment['addressId'] ?? 0;
            requiredFields = [...requiredFields, 'shippingMethodId', 'addressId', 'firstName', 'lastName', 'address1', 'city', 'countryName', 'stateName', 'postalCode', 'phone', 'phoneCountryCode', 'attention'];
            requiredFields.forEach((field: any) => {
                if (fieldConditionMatch(shipment, field)) {
                    shipment.error = { ...shipment.error, [field]: true };
                    isValid = false;
                }
            });

            isValid = shipmentPhoneValidation(isValid);
            if (props?.updateStepperDetails) {
                props.updateStepperDetails({ ...props?.stepperDetails, shipment });
            }
        }
        else {
            isValid = orderContactValidation(isValid);
        }
        
        return isValid;
    };

    const shipmentPhoneValidation = (isValid: any) => {
        const shipment = stepperDetails?.shipment ?? {};
        const phone = shipment?.phone ? shipment?.phone.replace(/\D/g, '') : '';
        const phoneCode = shipment?.phoneCountryCode ?? "";
        if (phoneCode?.length > 0 && phone?.length == 0) {
            shipment['error'] = { ...shipment?.error, phone: true };
            isValid = false;
        }
        if (phoneCode?.length == 0 && phone?.length > 0) {
            shipment['error'] = { ...shipment?.error, phoneCountryCode: true };
            isValid = false;
        }
        if (phoneCode == "+1" && phone?.length > 0 && phone?.length !== 10) {
            shipment['error'] = { ...shipment?.error, isInvalidPhone: true };
            isValid = false;
        }

        if (props?.updateStepperDetails) {
            props.updateStepperDetails({ ...props?.stepperDetails, shipment });
        }
        return isValid;
    }

    const orderContactValidation = (isValid: any) => {
        const shipment = stepperDetails?.shipment ?? {};
        const contactPhone = shipment?.contactPhone ? shipment?.contactPhone.replace(/\D/g, '') : '';
        const phoneCode = shipment?.contactPhoneCountryCode ?? "";
        if (phoneCode?.length > 0 && contactPhone?.length == 0)
        {
            shipment['error'] = { ...shipment?.error, contactPhone: true };
            isValid = false;
        }
        if (phoneCode?.length == 0 && contactPhone?.length > 0) {
            shipment['error'] = { ...shipment?.error, contactPhoneCountryCode: true };
            isValid = false;
        }
        if (phoneCode == "+1" && contactPhone?.length > 0 && contactPhone?.length !== 10) {
            shipment['error'] = { ...shipment?.error, isInvalidPhone: true };
            isValid = false;
        }

        if (props?.updateStepperDetails) {
            props.updateStepperDetails({ ...props?.stepperDetails, shipment });
        }
        return isValid;
    }

    const stepTwoValidationCheck = () => {
        const payment = stepperDetails?.payment ?? {};
        let isValid = true;
        payment['addressId'] = payment['addressId'] ?? 0;
        let requiredFields: any[] = ['paymentMethod'];
        if (payment.paymentMethod?.toLowerCase() == PAYMENTMETHOD[PAYMENTMETHOD.KC].toLowerCase()) {
            requiredFields = [...requiredFields, 'creditCardProfileId', 'addressId', 'firstName', 'lastName', 'address1', 'city', 'countryName', 'stateName', 'postalCode'];
        }
        else if (payment?.paymentMethod?.toLowerCase() == PAYMENTMETHOD[PAYMENTMETHOD.AC].toLowerCase()) {
            requiredFields = stepperDetails?.isPoNumberRequired ? [...requiredFields, 'poNumber'] : requiredFields;
        }
        requiredFields.forEach((field: any) => {
            if (fieldConditionMatch(payment, field)) {
                payment.error = { ...payment.error, [field]: true };
                isValid = false;
            }
        });
        if (payment.paymentMethod?.toLowerCase() == PAYMENTMETHOD[PAYMENTMETHOD.KC].toLowerCase() && (!payment?.creditCardProfileId) || payment?.creditCardProfileId < 0) {
            payment.error = { ...payment.error, creditCardProfileId: true };
            isValid = false;
        }
        if (props?.updateStepperDetails) {
            props.updateStepperDetails({ ...props?.stepperDetails, payment });
        }
        return isValid;
    };

    const [prevStepperDetails, setPrevStepperDetails] = useState<any>({});
    const [isNextClick, setIsNextClick] = useState(false);

    useEffect(() => {
        if(props?.stepperDetails){
            setIsNextClick(false)
        }
    }  ,[props?.stepperDetails]); 

    const saveFulfillmentType = async (data: any) => {
        try {
            const { isShipping, isPickup, isPickupAvailable, isPickupAvailablePlusShipping, isPickupAvailablePlusAdditionalPickup, isPickupWillCallKomatsuShipping } = data ?? {};
            setSavePickupRes({ loading: true, data: false });
            let type = '';
            if (isPickup) {
                type = 'Pickup';
            }
            else if (isPickupAvailable && isPickupAvailablePlusShipping) {
                type = 'PickupAvailablePlus_Shipping';
            }
            else if (isPickupAvailable && isPickupAvailablePlusAdditionalPickup) {
                type = 'PickupAvailablePlus_AdditionalPickup';
            }
            else if (isShipping) {
                type = 'Shipping';
            }
            else if (isPickupWillCallKomatsuShipping) {
                type = "PickupWillCall_KomatsuShipping"
            }
            if (type != '') {
                const req = {
                    cartId: cartsDetails?.cart?.cartId,
                    userAadId: headercurrentuser?.azureADId,
                    fulfillmentOption: type ?? ''
                }
                const response = await partsService.savePickupFulfillment(req);
                if (response?.isSuccess && response?.data) {
                    setSavePickupRes({ loading: false, data: response?.data ?? false });
                    props.getItemSummaryDetailsWithoutLoading();
                } else {
                    setSavePickupRes({ loading: false, data: false });
                    helperfunctions.showErrorMessage(`${response?.msg}`);
                }
            }
        } catch (error) {
            setSavePickupRes({
                loading: false, data: false
            });
            helperfunctions.showErrorMessage(`${error}`);
        }
    };

    const handleStepOne = async () => {
        let tabRef = formWizardRef.current;
        const isValid = stepOneValidationCheck();
        if (isValid) {
            setPrevStepperDetails({ ...prevStepperDetails, shipment: stepperDetails?.shipment ?? {} });
            const isSame = isEqual(prevStepperDetails?.shipment, stepperDetails?.shipment);
            if (!isSame || !props?.saveShipmentDetailsRes?.data?.isSuccessful) {
                const isSaveSuceess = await props?.saveShipmentDetails();
                if (isSaveSuceess) {
                    tabRef?.nextTab();
                    helperfunctions.scrollToTop();
                }
            }
            else if (savePickupRes?.data && props?.saveShipmentDetailsRes?.data?.isSuccessful) {
                tabRef?.nextTab();
                helperfunctions.scrollToTop();
            }
        }
    }

    const handleStepTwo = async () => {
        let tabRef = formWizardRef.current;
        const isValid = stepTwoValidationCheck();
        if (isValid) {
            setPrevStepperDetails({ ...prevStepperDetails, payment: stepperDetails?.payment ?? {} });
            const isSame = isEqual(prevStepperDetails?.payment, stepperDetails?.payment);
            if (!isSame || !props?.saveShipmentDetailsRes?.data?.isSuccessful) {
                const isSaveSuceess = await props?.savePaymentDetails();
                if (isSaveSuceess) {
                    tabRef?.nextTab();
                    helperfunctions.scrollToTop();
                }
                
            } else if (props?.savePaymentDetailsRes?.data?.isSuccessful) {
                tabRef?.nextTab();
                helperfunctions.scrollToTop();
            }
        }
    }

    const handelNext = () => {
        setIsNextClick(true);
        if (props?.currentStep === 1) {
            handleStepOne();
        }
        else if (props?.currentStep === 2) {
            handleStepTwo();
        }
        else if (props?.currentStep === 3) {
            props?.placeOrder();
        }
        else {
            formWizardRef.current?.nextTab();
            helperfunctions.scrollToTop();
        }
    };

    const checkoutOnClick = () => {
        setIsCheckoutButton(false);
        setIsCheckoutPage(true);
        setnextbutton(true);
    };

    const closeManufacturerMachineModel = () => {
        handleMandatoryErrorClose();
        props.isMachine ? props.toggleMachinePopupClick()
            : props.toggleManufacturePopupClick();
    }

    const updateMachine = () => {
        return props?.cartsDetails?.parts?.map((item: any) => {
            if (item.partNumber == props?.machineManufactureModel?.partNumber && item.cartDetailId == props?.machineManufactureModel?.cartDetailId && props?.machineManufactureModel?.childPartNumber) {

                return {
                    ...item,
                    substituteParts: item?.substituteParts?.map((child: any) => {
                        if (child.parentPartNumber == item.partNumber && child.partNumber == props?.machineManufactureModel?.childPartNumber) {
                            return {
                                ...child,
                                machine: props?.machineManufactureModel?.machine,
                            };
                        }

                        else {
                            return child;
                        }
                    })
                };
            }
            else if (item.partNumber == props?.machineManufactureModel?.partNumber && item.cartDetailId == props?.machineManufactureModel?.cartDetailId && !props?.machineManufactureModel?.childPartNumber) {
                return {
                    ...item,
                    machine: props?.machineManufactureModel?.machine
                };
            }
            else {
                return item;
            }
        }) ?? [];
    }

    const updateManufacture = () => {
        return props?.cartsDetails?.parts?.map((item: any) => {
            if (item.partNumber == props?.machineManufactureModel?.partNumber && item.cartDetailId == props?.machineManufactureModel?.cartDetailId && props?.machineManufactureModel?.childPartNumber) {
                return {
                    ...item,
                    substituteParts: item?.substituteParts?.map((child: any) => {
                        if (child.parentPartNumber == item.partNumber && child.partNumber == props?.machineManufactureModel?.childPartNumber) {
                            return {
                                ...child,
                                manufacturer: props?.machineManufactureModel?.manufacturer,
                            };
                        }

                        else {
                            return child;
                        }
                    })
                };
            }
            else if (item.partNumber == props?.machineManufactureModel?.partNumber && item.cartDetailId == props?.machineManufactureModel?.cartDetailId && !props?.machineManufactureModel?.childPartNumber) {
                let refreshCartList = props?.refreshCartRequiredParts;
                if (!props?.refreshCartRequiredParts.includes(item.cartDetailId)) {
                    refreshCartList.push(item.cartDetailId);
                    props?.setRefreshCartRequiredParts(refreshCartList);
                }
                return {
                    ...item,
                    manufacturer: props?.machineManufactureModel?.manufacturer
                };
            }
            else {
                return item;
            }
        });
    }

    const manufactureOnClick = () => {
        let parts: any = [];
        let updateCartRequired = true;
        if (props.isMachine) {
            if (!props?.machineManufactureModel?.machine || (props?.machineManufactureModel?.machine.mDbId < 0)) {
                showMandtoryErrorMessage(t(RESOURCE.MyK_Info_PleaseSelectMachine));
                updateCartRequired = false;
            }
            else {
                parts = updateMachine();
                props.toggleMachinePopupClick();
            }
        }
        else {
            parts = updateManufacture() ?? [];
            props.toggleManufacturePopupClick();
        }
        if (updateCartRequired) {
            props?.setCartDetails((prevState: any) => ({ ...prevState, parts: parts }));
            const model = {
                cart: props?.cartsDetails?.cart,
                parts: parts
            }
            props?.updateCartItem(model);
        }
    };

    const handleErrorClose = () => {
        setErrorSuccessMessage('');
        setShowAlert(false);
    };

    const getMachineOrManufactureTitle = () => {
        return props.isMachine ? t(RESOURCE.MyK_Label_ShoppingCart_Select_Machine) : t(RESOURCE.MyK_Label_ShoppingCart_Select_Manufacturer);
    }

    const isLoaderVisible = () => {
        return ((props?.placeOrderRes?.loading ||
            props?.clearCartCheckOutDatarRes?.loading || props.isMaintenancePartLoading ||
            props.isFetchingCartItems || saveCartRes?.loading ||
            props?.itemSummaryDetails?.loading || props?.customerCreditInfo?.loading || isCartListLoading
        ) && <span className="scLoader"><Loader /></span>);
    }

    const showPunchooutHistoryOrKomatsuCreditHistory = () => {
        return (<>
            {showPuchoutHistory && <PunchOutHistory />}
            {showKomatsuCreditHistory && <KomatsuCreditHistory />}
        </>)
    }

    return (
        <CartContext.Provider value={contextValue}>
            <div className="shoppingcart_wrapper">
                {isLoaderVisible()}
                <BreadCrumbs showKomatsuCreditHistory={showKomatsuCreditHistory} showPuchoutHistory={showPuchoutHistory} getMachineManufacturePunchoutButton={props?.getMachineManufacturePunchoutButton}
                    clearMachineManufacturePunchoutButton={props?.clearMachineManufacturePunchoutButton} isCheckoutPage={isCheckoutPage} setCartDetails={props.setCartDetails} isPriceAndAvailabilityRequired={isPriceAndAvailabilityRequired} setIsPriceAndAvailabilityRequired={setIsPriceAndAvailabilityRequired} isShoppingCart={isShoppingCart} shoppingcartOnClick={shoppingcartOnClick} />
                {istoolmenu &&
                    <div className="tool_menu-Wrapper" onClick={toolmenuOnclick} onKeyDown={() => { }}>
                        {cartToolMenu ? (
                            <>
                                <span className="tool_menu-symbol tool_menu-plus">+</span>
                                <span className="tool_menu-Text tool_menu-plusText" title={t(RESOURCE.MyK_Label_ShoppingCart_Show_Cart_Tools_Menu)}>
                                    {t(RESOURCE.MyK_Label_ShoppingCart_Show_Cart_Tools_Menu)}
                                </span>
                            </>

                        ) : (
                            <>
                                <span className="tool_menu-symbol tool_menu-minus">-</span>
                                <span className="tool_menu-Text tool_menu-minusText" title={t(RESOURCE.MyK_Label_ShoppingCart_Hide_Cart_Tools_Menu)}>
                                    {t(RESOURCE.MyK_Label_ShoppingCart_Hide_Cart_Tools_Menu)}
                                </span>
                            </>

                        )}
                    </div>
                }
                {!cartToolMenu && <ShoppingCartHeading showKomatsuCreditHistory={showKomatsuCreditHistory} komatsuCreditHistoryButtonVisibility={komatsuCreditHistoryButtonVisibility} punchoutButtonVisibility={punchoutButtonVisibility} cartsDetails={props.cartsDetails} uploadOnClick={uploadOnClick} savedpartsOnClick={() => savedpartsOnClick()} puchoutHistoryOnClick={puchoutHistoryOnClick} komatsuCreditHistoryOnClick={komatsuCreditHistoryOnClick} showPuchoutHistory={showPuchoutHistory} quotesOnClick={quotesOnClick} isPartNumber={props.isPartNumber} historyOnClick={historyOnClick} />}

                <div className="shoppingcart_content-Wrapper">
                    {(showPuchoutHistory || showKomatsuCreditHistory) ? showPunchooutHistoryOrKomatsuCreditHistory() :
                        <>
                            {isShoppingCart &&
                                <div className="shoppingcart_left-Container">
                                    {(!cartToolMenu && props?.isRefreshing) && <div className="scLoader">
                                        <ShoppingCartLoader />
                                    </div>}
                                    <IteminCart
                                        cartsDetails={props.cartsDetails}
                                        cartToolMenu={cartToolMenu}
                                        isPartNumber={props.isPartNumber}
                                        SaveOnClick={SaveOnClick}
                                        ShareOnClick={ShareOnClick}
                                        handleDeselectAll={props.handleDeselectAll}
                                        handleParentChange={props.handleParentChange}
                                        childCheckboxes={props.childCheckboxes}
                                        showAlert={showAlert}
                                        errorSuccessMessage={errorSuccessMessage}
                                        handleErrorClose={handleErrorClose}
                                        DeleteOnClick={DeleteOnClick}
                                        itemSummaryDetails={props.itemSummaryDetails}
                                        alertType={alertType}
                                    />
                                    <AddPartNumber
                                        setIsPriceAndAvailabilityRequired={setIsPriceAndAvailabilityRequired}
                                        cartToolMenu={cartToolMenu}
                                        onHandlePartNo={props.onHandlePartNo}
                                        isPartNumber={props.isPartNumber}
                                        manufactureOption={props.manufactureOption}
                                        machineOption={props.machineOption}
                                        onRefresh={props.onRefresh}
                                        getCartItems={props.getCartItems}
                                        cartsDetails={props.cartsDetails}
                                        setRefreshCartRequiredParts={props?.setRefreshCartRequiredParts}
                                        refreshCartRequiredParts={props?.refreshCartRequiredParts}
                                        isRefreshing={props?.isRefreshing}
                                        getMiningParts={props?.getMiningParts}
                                        getAdminFlag={props?.getAdminFlag}
                                    />
                                    <div className="shoppingcart_partnumber-Warapper">
                                        {(props?.cartsDetails?.parts?.length > 0 ?
                                            <PartNumberCard
                                                manufacturePopup={props.manufacturePopup}
                                                productRecommendationPopupClick={props.productRecommendationPopupClick}
                                                toggleManufacturePopupClick={props.toggleManufacturePopupClick}
                                                isMachine={props.isMachine}
                                                toggleMachinePopupClick={props.toggleMachinePopupClick}
                                                manufactureValue={manufactureValue}
                                                machineValue={machineValue}
                                                ReturnableOnClick={ReturnableOnClick}
                                                estOnClick={estOnClick}
                                                cartsDetails={props.cartsDetails}
                                                handleChildChange={props.handleChildChange}
                                                childCheckboxes={props.childCheckboxes}
                                                partnumberchild={props.cartsDetails?.parts}
                                                partNumberRedirect={props.partNumberRedirect}
                                                setCartDetails={props.setCartDetails}
                                                updateCartQuantity={props.updateCartQuantity}
                                                setMachineManufactureModel={props.setMachineManufactureModel}
                                                refreshCartRequiredParts={props?.refreshCartRequiredParts}
                                                isFetchingCartItems={props?.isFetchingCartItems}
                                                handleManufactureOption={handleManufactureOption}
                                            />
                                            :
                                            <div className='emptyCard_wrapper'>
                                                <div className='emptyCard_header'>{t(RESOURCE.MyK_Label_SC_Partlist_Cart_Empty)}</div>
                                                <p className='emptyCard_text'>{t(RESOURCE.MyK_Label_SC_Partlist_Cart_Empty_Text)}</p>
                                            </div>
                                        )
                                        }

                                        {!headercurrentuser?.isGuestUser && <div><MaintenancePartList
                                            onRefresh={props.onRefresh}
                                            setIsMaintenancePartLoading={props.setIsMaintenancePartLoading}
                                            isMaintenancePartLoading={props.isMaintenancePartLoading}
                                            getCartItems={props.getCartItems}
                                            partNumberRedirect={props.partNumberRedirect}
                                            maintenancePartsList={props.maintenancePartsList}
                                            setMaintenancePartModel={props.setMaintenancePartModel}
                                            setMaintenancePartSerial={props.setMaintenancePartSerial}
                                            setMaintenancePartsList={props.setMaintenancePartsList}
                                            getMiningParts={props.getMiningParts}
                                        /></div>}

                                        {(isMixedFleetDistributor || isWacMixedFleetDistributor) && <div>
                                            <MiningPartsLists getMiningParts={props?.getMiningParts} miningParts={props?.miningParts} getPartsListItems={props?.getPartsListItems} />
                                        </div>}
                                    </div>

                                </div>
                            }

                            {!placeOrderRes?.data?.isSuccessful && isordersummary &&
                                <DropShip
                                isPromoChanges={isPromoChanges}
                                getItemSummaryDetailsWithoutLoading={props.getItemSummaryDetailsWithoutLoading}
                                itemSummaryDetails={props?.itemSummaryDetails}
                                fulfillmentDetailRes={fulfillmentDetailRes}
                                cartsDetails={props?.cartsDetails}
                                setActive={setActive}
                                shoppingcartOnClick={shoppingcartOnClick}
                                getAvailabilityDetails={props?.getAvailabilityDetails}
                                availabilityDetails={props?.availabilityDetails}
                                getIsNextDisableStatus={props?.getIsNextDisableStatus}
                                updateStepperDetails={props?.updateStepperDetails}
                                phoneCodeOption={phoneCodeOption}
                                formWizardRef={formWizardRef}
                                saveFulfillmentType={saveFulfillmentType}
                                isNextClick={isNextClick}
                            />
                            }
                            {placeOrderRes?.data?.isSuccessful &&
                                <div className="confirmation-fullwidth">
                                    <div className='ml-2 mt-2'>
                                        <span className='backtocart confirmation-backtoCart' title={t(RESOURCE.MyK_Label_ShoppingCart_Back_To_Cart)} onClick={shoppingcartOnClick} onKeyDown={() => { }} >{t(RESOURCE.MyK_Label_ShoppingCart_Back_To_Cart)}</span>
                                    </div>
                                    <Confirmation phoneCodeOption={phoneCodeOption} />  
                                </div>
                                
                            }
                            {!placeOrderRes?.data?.isSuccessful && !isHideItemSummary && <div className={`shoppingcart_right-Container`}>
                                <ShoppingCartPromo
                                    showPartCreditWhenPromoApplied={showPartCreditWhenPromoApplied}
                                    CheckoutPageTransfer={CheckoutPageTransfer}
                                    isPromoChanges={isPromoChanges}
                                    setIsPromoChanges={setIsPromoChanges}
                                    quantityChange={props.quantityChange}
                                    getItemSummaryDetailsWithoutLoading={props.getItemSummaryDetailsWithoutLoading}
                                    isDisableNext={props?.isDisableNext} getItemSummaryDetails={props.getItemSummaryDetails}
                                    itemSummaryDetails={props.itemSummaryDetails} getCartItems={props?.getCartItems}
                                    cartsDetails={props?.cartsDetails}
                                    productRecommendationPopupClick={props.productRecommendationPopupClick}
                                    isActive={isActive} isnextbutton={isnextbutton}
                                    isCheckoutButton={isCheckoutButton}
                                    isPlaceOrderButton={props?.isPlaceOrderButton}
                                    isPunchOutUser={props?.isPunchOutUser}
                                    isPunchOutDistributorUser={props?.isPunchOutDistributorUser}
                                    customerCreditInfo={props?.customerCreditInfo}
                                    getCustomerCreditInfo={props?.getCustomerCreditInfo}
                                    Ordersummaryonclick={Ordersummaryonclick} handelNext={handelNext}
                                    isApplyCredit={isApplyCredit}
                                    setIsApplyCredit={setIsApplyCredit}
                                />
                            </div>}
                        </>
                    }
                </div>

                {props.productRecommendationPopup && (
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Product_Recommendation)}
                        ModalPopupType="Xl"
                        closeModalPopup={() => {
                            props.productRecommendationPopupClick("");
                            if(props?.isPartAdded) {
                                shoppingcartOnClick();
                                props?.onRefresh(null, true)
                            }
                        }}
                    >
                        <ProductRecommendation getMiningParts={props?.getMiningParts} updateIsPartAddedStatus={props?.updateIsPartAddedStatus} onRefresh={props.onRefresh} cartsDetails={props?.cartsDetails} cartItem={props?.cartItem} savedpartsOnClick={() => savedpartsOnClick()} getCartItems={props.getCartItems} partNumberRedirect={props.partNumberRedirect} />
                    </ModalPopup>
                )}
                {(props.manufacturePopup || props.isMachine) && (
                    <div>
                        <ModalPopup
                            ShowModalPopupFooter={true}
                            ModalPopupTitle={getMachineOrManufactureTitle()}
                            ModalPopupType="medium"
                            closeModalPopup={
                                closeManufacturerMachineModel
                            }
                            ModalPopupName='Machinemanufacture'
                        >
                            <div className="machineModalPopUp">

                                {showMandatoryAlert && (
                                    <Alerts
                                        messageAlert={errorMandatoryMessage}
                                        alertType={'error'}
                                        time={3000} onClose={() => handleMandatoryErrorClose()}
                                    />
                                )}

                                <label className="popupHeader">
                                    {props.isMachine ? t(RESOURCE.MyK_Label_ShoppingCart_Select_Machine) : t(RESOURCE.MyK_Label_ShoppingCart_Select_Manufacturer)}
                                </label>

                                <TreeviewDropdown
                                    treeData={props.isMachine ? props?.machineOption : props?.manufactureOption}
                                    showSearch={true}
                                    multiple={false}
                                    treeNodeFilterProp={"title"}
                                    className={"multislectDropdown mt-2"}
                                    dropdownClassName={"dropdownListContainer noNested"}
                                    placeholder={""}
                                    value={props.isMachine ? (props?.machineManufactureModel?.machine?.mDbId > 0 ? props?.machineManufactureModel?.machine?.mDbId : "") : props?.machineManufactureModel?.manufacturer?.code}
                                    onChange={(value: any, text: any) => {
                                        handleOnChange(
                                            value,
                                            text,
                                            props.isMachine ? "machine" : "manufacturer"
                                        );
                                    }}
                                />

                                <button
                                    className="UpdateBtn mt-5"
                                    onClick={manufactureOnClick}
                                    title={t(RESOURCE.MyK_Label_ShoppingCart_Update)}
                                >
                                    {t(RESOURCE.MyK_Label_ShoppingCart_Update)}
                                </button>
                            </div>
                        </ModalPopup>
                    </div>
                )}
                {isReturnable && (
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Return_Policy)}
                        ModalPopupType="large"
                        closeModalPopup={ReturnableOnClick}
                    >
                        <div className="Returnpolicy_label mb-2">{t(RESOURCE.MyK_Label_ShoppingCart_Return_Policy)}</div>
                        <div className="Returnpolicy_Discription">
                            {t(RESOURCE.MyK_Label_ShoppingCart_Return_Policy_Text)}
                        </div>
                        <div className="returnpolicy_backbutton">
                            <button
                                className="UpdateBtn mt-5"
                                onClick={ReturnableOnClick}
                                title={t(RESOURCE.MyK_Label_ShoppingCart_Back)}
                            >
                                {t(RESOURCE.MyK_Label_ShoppingCart_Back)}
                            </button>
                        </div>
                    </ModalPopup>
                )}
                {isEstimatedPopup && (
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Freight_Calculator)}
                        ModalPopupType="medium"
                        closeModalPopup={estOnClick}
                    >
                        <FreightCalculator cartsDetails={props?.cartsDetails} partNumber={estPartNumber} getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading} />
                    </ModalPopup>
                )}
                {
                    isSaveCartPopup && <SaveCartPopUp
                        SaveOnClick={(saveInfo: any) => onSaveCartChange(saveInfo)}
                        closePopup={closePopup}
                        isQuote={false}
                    />
                }
                {
                    isUploadPopup &&
                    <ModalPopup
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Upload_Parts_List)}
                        ModalPopupType="Xl"
                        closeModalPopup={uploadOnClick}>
                        <UploadPartsList uploadOnClick={uploadOnClick} manufactureOption={props.manufactureOption}
                            headercurrentuser={headercurrentuser} getCartItems={props.getCartItems} onRefresh={props.onRefresh}
                            globalData={globalData}
                            getMiningParts={props?.getMiningParts}
                        />
                    </ModalPopup>
                }
                {
                    isSavedPartsPopup &&
                    <ModalPopup
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Saved_Parts_List)}
                        ModalPopupType="Xl"
                        closeModalPopup={() => savedpartsOnClick()}>
                        <SavePartList
                            setPartsListItemsGrid={props.setPartsListItemsGrid}
                            getBookmarkItems={props.getBookmarkItems}
                            getPartsListItemsForGrid={props.getPartsListItemsForGrid}
                            getPartsListItems={props?.getPartsListItems}
                            bookmarkItems={props.bookmarkItems}
                            listType={props.listType}
                            getCartItems={props.getCartItems}
                            partsListItemsGrid={props.partsListItemsGrid}
                            setBookmarkItems={props.setBookmarkItems}
                            onRefresh={props.onRefresh}
                            getMiningParts={props?.getMiningParts}
                            isFetchingPartsListItems={props?.isFetchingPartsListItems}
                            setListType={props.setListType} addtoListOnClick={addtoListOnClick} setSelectedBookmarkItem={props.setSelectedBookmarkItem} selectedBookmarkItem={props.selectedBookmarkItem} />
                    </ModalPopup>
                }
                {
                    isAddtoListPopup &&
                    <ModalPopup
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_PartList_Add_Part_Number)}
                        ModalPopupType="large"
                        closeModalPopup={addtoListOnClick}>
                        <AddPartList getBookmarkItems={props.getBookmarkItems}
                            getPartsListItemsForGrid={props.getPartsListItemsForGrid} addtoListOnClick={addtoListOnClick} selectedBookmarkItem={props.selectedBookmarkItem} partsListItems={props.partsListItems} />
                    </ModalPopup>
                }
                {
                    isDealerAvilablityPopup &&
                    <ModalPopup
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Dealer_Availability)}
                        ModalPopupType="medium"
                        closeModalPopup={dealerAvilablityOnClick}>
                        <DealerAvailability />
                    </ModalPopup>
                }
                {
                    isSharePopup &&
                    <ModalPopup
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Share)}
                        ModalPopupType="large"
                        closeModalPopup={ShareOnClick}>
                            <SharePartList childCheckboxes={props.childCheckboxes} isMiningCart={false} shareOnClick={ShareOnClick} cartsDetails={props.cartsDetails} />
                    </ModalPopup>
                }
                {
                    isQuotesPopup &&
                    <ModalPopup
                        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Quote)}
                        ModalPopupType="Xl"
                        closeModalPopup={quotesOnClick}>
                        <Quotes getMiningParts={props?.getMiningParts} quoteId={quoteId} setQuoteId={setQuoteId} onRefresh={props.onRefresh} getCartItems={props.getCartItems} cartsDetails={props.cartsDetails} getPartsListItems={props.getPartsListItems} />
                    </ModalPopup>
                }
            </div>
        </CartContext.Provider>
    );
}

export default ShoppingCart;

export const useCartContext = (): ICartContextType => {
    return useContext(CartContext);
};